import {BackgroundImage, Box, Flex, Grid, Text} from "@mantine/core";
import {decode} from "html-entities";


const _CategoryWithProductTheme5 = ({component}) => {
    return (
        <Box
            mx={component?.customize_styles?.general_decoration?.margin_x}
            my={component?.customize_styles?.general_decoration?.margin_y}
            px={component?.customize_styles?.general_decoration?.padding_x}
            py={component?.customize_styles?.general_decoration?.padding_y}
            bg={component?.customize_styles?.general_decoration?.background_color}
            style={{
                boxShadow: `${component?.customize_styles?.general_decoration?.shadow_offset_x}px ${component?.customize_styles?.general_decoration?.shadow_offset_y}px ${component?.customize_styles?.general_decoration?.shadow_blur_radius}px ${component?.customize_styles?.general_decoration?.shadow_blur_radius}px #00000014`,
                borderRadius: `${component?.customize_styles?.general_decoration?.border_radius}px`,
                border: `${component?.customize_styles?.general_decoration?.border_width}px solid ${component?.customize_styles?.general_decoration?.border_color}`,
            }}

        >
            <Text
                fz="18px"
                c={component?.customize_styles?.text_decoration?.color}
                mx={component?.customize_styles?.text_decoration?.margin_x}
                my={component?.customize_styles?.text_decoration?.margin_y}
                px={component?.customize_styles?.text_decoration?.padding_x}
                py={component?.customize_styles?.text_decoration?.padding_y}
                bg={component?.customize_styles?.text_decoration?.background_color}
                lh='1'
                fw={700}
            >
                {component?.customize_properties?.label}
            </Text>
            <Grid mt={12} gutter={0}>

                {
                    component?.items?.map((item, index) => (
                        <Grid.Col span={6} key={index}>
                            <Box
                                mx={component?.customize_styles?.box_decoration?.margin_x}
                                my={component?.customize_styles?.box_decoration?.margin_y}
                                px={component?.customize_styles?.box_decoration?.padding_x}
                                py={component?.customize_styles?.box_decoration?.padding_y}
                                bg={component?.customize_styles?.box_decoration?.background_color}
                                style={{
                                    boxShadow: `${component?.customize_styles?.box_decoration?.shadow_offset_x}px -${component?.customize_styles?.box_decoration?.shadow_offset_y}px ${component?.customize_styles?.box_decoration?.shadow_blur_radius}px ${component?.customize_styles?.box_decoration?.shadow_blur_radius}px #00000014`,
                                    borderRadius: `${component?.customize_styles?.box_decoration?.border_radius}px`,
                                    border: `${component?.customize_styles?.box_decoration?.border_width}px solid ${component?.customize_styles?.box_decoration?.border_color}`,
                                }}
                            >
                                <BackgroundImage
                                    radius={component?.customize_styles?.image_decoration?.radius}
                                    h={190}
                                    src={item.image_url}
                                >
                                </BackgroundImage>
                                <Box>
                                    <Text
                                        c={component?.customize_styles?.name_text_decoration?.color}
                                        fw={component?.customize_styles?.name_text_decoration?.font_weight}
                                        fz={component?.customize_styles?.name_text_decoration?.font_size}
                                        fs={component?.customize_styles?.name_text_decoration?.font_style}

                                        mt={12}
                                        tt="capitalize"
                                        lh="18px"
                                        lineClamp={1}
                                        translate="yes"
                                    >
                                        {item?.name}
                                    </Text>

                                    <Text
                                        lineClamp={1}
                                        translate="yes"
                                        c={component?.customize_styles?.product_category_text_decoration?.color}
                                        fz={12}
                                    >
                                        {item.product_categories.toString()}
                                    </Text>
                                </Box>
                                <Flex align="center" justify="space-between">
                                    <Box>
                                        <Text
                                            c={component?.customize_styles?.product_price_text_decoration?.color}
                                            bg={component?.customize_styles?.product_price_text_decoration?.background_color}
                                            fw={component?.customize_styles?.product_price_text_decoration?.font_weight}
                                            fz={component?.customize_styles?.product_price_text_decoration?.font_size}
                                            lh={1}
                                        >
                                            {decode(item?.currency)} {item?.discount_price ? item.discount_price : item?.price}
                                        </Text>
                                    </Box>
                                </Flex>
                            </Box>
                        </Grid.Col>
                    ))
                }
            </Grid>
        </Box>
    )
}
export default _CategoryWithProductTheme5;